<template>
  <div class="form-group">
    <div class="w100 mtop20 contTable">
      <b-table
    class="poolTable"
    ref="table"
    :items="alarms"
    :fields="fields"
    :sort-compare="sortCompare"
    head-variant="light"
    hover
  >
      <template v-slot:type="{ item, value }">
        {{ getTypeLabel(item) }}
      </template>
      <!-- Yes / no -->
      <template #cell(emailEnabled)="{ value }">
        {{ value ?  $t("messages.yes") : $t("messages.no")  }}
      </template>
      <template #cell(pushEnabled)="{ value }">
        {{ value ?  $t("messages.yes") : $t("messages.no") }}
      </template>
      <template #cell(lastSend)="{ value }">
        {{ getLastSend(value) }}
      </template>
      <template #cell(createdAt)="{ value }">
        {{ value | moment("DD-MM-YYYY HH:mm") }}
      </template>
      <template #cell(frequency)="{ value }">
        {{ getFrequency(value)}}
      </template>
      <template #cell(actions)="data">
        <button class="btnTable" @click="edit(data.item)"><icon name="edit"></icon></button>
        <button class="btnTable" v-b-modal.modalDelete @click="selectedAlarm = data.item"><icon name="trash"></icon></button>
      </template>
  </b-table>
        </div>
        <b-button class="right mtop20 btn btnDefault btnAdd" @click="addAlarm()">
            {{ $t("messages.addAlarm") }}
        </b-button>
      
        <modal
          name="add-alarm"
          transition="nice-modal-fade"
          classes="modal-detail"
          :pivot-y="0.5"
          :adaptive="true"
          :scrollable="true"
          :reset="true"
          width="35%"
          height="350"
          :clickToClose="false"
        >
      <div class="modal-detail-content">
        <b-btn @click="closeModal()" class="closePopup">
          <icon name="times-circle"></icon>
        </b-btn>
        <b-col>
          <!-- edit alarm /new alarm -->
          <h4>{{ selectedAlarm.id ? $t("messages.editAlarm") : $t("messages.newAlarm") }}</h4>
          <form @submit.prevent>
            <b-row>
              <b-col cols="4" class="right normal">
                <label class="w100 right">{{ $t("messages.type") }}</label>
              </b-col>
              <b-col cols="6">
                <select
                  class="form-control"
                  :required="true"
                  v-model="selectedAlarm.type"
                  @change="changeType">
                  <option
                    v-for="option in types"
                    :key="option.value"
                    v-bind:value="option.value"
                    :selected="getSelected(option.value)"
                    :disabled="!option.disabled"
                    :data-activationonly="option.activationOnly">
                    {{ option.label }}
                  </option>
                </select>
              </b-col>
            </b-row>
              <!-- notifies -->
              <b-row class="mtop10">
                <b-col cols="4" class="right normal">
                  <label class="w100 right ptop15 ptop0mobile">{{ $t("messages.emailEnabled") }}</label>
                </b-col>
                <b-col cols="4" class="left normal">
                  <md-switch class="md-primary" v-model="selectedAlarm.emailEnabled"></md-switch>
                </b-col>
              </b-row>
              <b-row class="mtop10">
                <b-col cols="4" class="right normal">
                  <label class="w100 right ptop15 ptop0mobile">{{ $t("messages.pushEnabled") }}</label>
                </b-col>
                <b-col cols="4" class="left normal">
                  <md-switch class="md-primary" v-model="selectedAlarm.pushEnabled"></md-switch>
                
                </b-col>
              </b-row>
              <b-row v-if="selectedAlarm.pushEnabled">
                <b-alert style="margin-left: 30px;" show variant="info"><icon name="info-circle"> </icon>
                  <p>{{ $t("messages.pushInfo") }}</p>
                </b-alert>
              </b-row>
      
            <b-row class="mtop10">
              <!-- frequency -->
              <b-col cols="4" class="right">
                <label class="w100 right">{{ $t("messages.frequency") }}</label>
              </b-col>
              <b-col cols="7">
                <select class="form-control" :required="true" v-model="selectedAlarm.frequency">
                  <option
                    v-for="option in getFreqs"
                    :key="option.value"
                    v-bind:value="option.value"
                    :selected="option.value == selectedAlarm.frequency"
                  >{{ option.label }}</option>
                </select>
              </b-col>
            </b-row>
            <b-row class="mtop10">
              <!-- min value -->
              <b-col cols="4" class="right">
                <label class="w100 right">{{ $t("messages.minValue") }}</label>
              </b-col>
              <b-col cols="7">
                <b-form-input
                  type="text"
                  placeholder="Min value"
                  v-model.number="selectedAlarm.minValue"
                  :disabled="activationOnly"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mtop10">
              <!-- max value -->
              <b-col cols="4" class="right">
                <label class="w100 right">{{ $t("messages.maxValue") }}</label>
              </b-col>
              <b-col cols="7">
                <b-form-input
                  type="text"
                  placeholder="Max value"
                  v-model.number="selectedAlarm.maxValue"
                  :disabled="activationOnly"
                ></b-form-input>
              </b-col>
            </b-row>
            <!-- update / save  -->
            <button class="button mtop20 btnPerso save" @click="onUpdate(selectedAlarm.id)">
              {{ selectedAlarm.id ? $t("messages.update"): $t("messages.save")}}
              <icon name="save"></icon>
            </button>
          </form>
        </b-col>
      </div>
    </modal>
    <b-modal id="modalDelete" ref="modal" title="Delete alarm" class="modal-pos">
      <b-container>
        <!-- delete from your list alarm -->
        <p>
          {{ $t("messages.deleteAlarm") }}
          <strong>{{ selectedAlarm.type }}</strong>?
        </p>
      </b-container>
      <div slot="modal-footer">
        <button class="float-right btn btnPerso delete" @click="onDelete(selectedAlarm)">
          <!-- remove -->
          {{ $t("messages.remove") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Alarm from "./utils/Alarm.vue";
import Vue from "vue";

export default {
  name: "Alarms",
  components: {
    Alarm
  },
  props: {
    poolData: null
  },
  watch: {
    "$i18n.locale": function(oldV, newV) {
      this.resetColumns();
    }
  },
  data() {
    return {
      row:{},
      activationOnly: false,
      alarms: [],
      defaultAlarm: {
        type: null,
        frequency: "21600",
        emailEnabled: true,
        pushEnabled: false
      },
      selectedAlarm: {},
      
      fields: [
        {key: "type",label: this.$i18n.t("messages.type"),t: "messages.type",sortable: true},
        {
          key: "frequency",
          sortable: true,
          label: this.$i18n.t("messages.frequency"),
          t: "messages.frequency"
        },
        {
          key: "minValue",
          label: this.$i18n.t("messages.minValue"),
          t: "messages.minValue"
        },
        {
          key: "maxValue",
          label: this.$i18n.t("messages.maxValue"),
          t: "messages.maxValue"
        },
        {
          key: "emailEnabled",
          label: this.$i18n.t("messages.emailEnabled"),
          t: "messages.emailEnabled",
        },
        {
          key: "pushEnabled",
          label: this.$i18n.t("messages.pushEnabled"),
          t: "messages.pushEnabled"
        },
        {
          key: "lastSend",
          sortable: true,
          label: this.$i18n.t("messages.lastSend"),
          t: "messages.lastSend"
        },
        {
          key: "createdAt",
          sortable: true,
          label: this.$i18n.t("messages.createdAt"),
          t: "messages.createdAt"
        },
        {
          key: "actions",
          label: this.$i18n.t("messages.actions"),
          t: "messages.actions"
        }
      ],
      types: [],
      available:[]
    };
  },
  mounted() {
    this.getDataFromApi();
  },
  computed:{
    ...mapState(['userProfile']),
    getFreqs(){
      return [
        // hour days daily weekly
        {
          value: "3600",
          label: "1 " + this.$i18n.t("messages.hour"),
          t: "messages.hour"
        },
        {
          value: "21600",
          label: "6 " + this.$i18n.t("messages.hours"),
          t: "messages.hours"
        },
        {
          value: "86400",
          label: this.$i18n.t("messages.daily"),
          t: "messages.daily"
        },
        {
          value: "172800",
          label: this.$i18n.t("messages.2daily"),
          t: "messages.2daily"
        },
        {
          value: "259200",
          label:  this.$i18n.t("messages.3daily"),
          t: "messages.3daily"
        },
        {
          value: "345600",
          label:  this.$i18n.t("messages.4daily"),
          t: "messages.4daily"
        },
        {
          value: "432000",
          label: this.$i18n.t("messages.5daily"),
          t: "messages.5daily"
        }
      ]
    }

  },
  methods: {
    closeModal(){
      this.$modal.hide('add-alarm');
      this.selectedAlarm.type = null
    },
    getSelected(val){
      if(!this.selectedAlarm.type && this.available.length > 0){
          this.selectedAlarm.type = this.available[0].value
          this.activationOnly = this.available[0].activationOnly
      }
      if(val === this.selectedAlarm.type){
        return true
      } 

    },
    edit(alarm) {
      this.selectedAlarm = JSON.parse(JSON.stringify(alarm));
      var alarm = this.types.find(x => x.value === String(this.selectedAlarm.type));

      this.activationOnly = alarm.activationOnly
      this.$modal.show("add-alarm");
    },
    resetColumns() {
      this.$refs.table.fields.forEach(column => {
        if (column.t) {
          column.label = this.$i18n.t(column.t);
        }
      });
    },
    getDataFromApi() {
      this.loading = true;
      if(this.poolData.isDemo){
        this.availableTypes();
      }else{
      this.$store.dispatch("fetchUserAlarms", this.poolData.id).then(
        response => {
          this.alarms = response;
          this.availableTypes();
        },
        error => {
          // error retrieving data
          this.message = this.$t("messages.retrieveDataError");
        }
      );
      }
    },
    getFrequency(val) {
      try{
        let freq = this.getFreqs.find(x => x.value === String(val));
        return freq.label;
      }catch(err){
        console.log('no frequency');
      }
    },
    getTypeLabel(val) {
      try{
        let type = this.types.find(x => x.value === String(val));
        return type.label;
      }catch(err){
        console.log('no label');
      }

    },
    getLastSend(val) {
      let date = "---";
      if (val > 0) {
        date = this.$moment.unix(val).format("DD-MM-YYYY HH:mm");
      }
      return date;
    },
    addAlarm() {
      this.selectedAlarm = this.defaultAlarm;
      this.$modal.show("add-alarm");
    },
    changeType: function(e) {
      if (e.target.options.selectedIndex > -1) {
        this.activationOnly = Boolean(
          e.target.options[e.target.options.selectedIndex].dataset
            .activationonly
        );
      }
    },
    availableTypes() {
      let temp = [
        {
          value: "ph",
          label: "PH",
          disabled: this.poolData.main.hasPH && this.checkIfAlarmExists("ph")
        },
        {
          value: "rx",
          label: "RX",
          disabled: this.poolData.main.hasRX && this.checkIfAlarmExists("rx")
        },
        {
          value: "cl",
          label: "CL",
          disabled: this.poolData.main.hasCL && this.checkIfAlarmExists("cl")
        },
        {
          value: "cd",
          label: "CD",
          disabled: this.poolData.main.hasCD && this.checkIfAlarmExists("cd")
        },
        {
          value: "temp",
          label: this.$t("messages.temperature"),
          disabled:
            this.poolData.main.hideTemperature === 0 &&
            this.checkIfAlarmExists("temp")
        },
        {
          value: "al3",
          label: "PH AL3",
          disabled: this.poolData.main.hasPH && this.checkIfAlarmExists("al3"),
          activationOnly: true
        },{
          value: "fl2",
          label: "FL2",
          disabled: this.poolData.main.hasCL && this.checkIfAlarmExists("fl2"),
          activationOnly: true
        },
        {
          value: "fl1",
          label: "FL1",
          disabled: (this.poolData.main.hasRX || this.poolData.main.hasPH)  && this.checkIfAlarmExists("fl1"),
          activationOnly: true
        },
        {
          value: "tank",
          label: "TANK",
          disabled: (this.poolData.main.hasRX || this.poolData.main.hasPH || this.poolData.main.hasCD || this.poolData.main.hasCL)  && this.checkIfAlarmExists("fl1"),
          activationOnly: true
        }
      ];
      
      if(this.userProfile.company !=3 && this.poolData.main.hasHidro && this.poolData.main.version >=826){
        temp.push( {
          value: "al4",
          label: "AL4",
          disabled: this.poolData.main.hasHidro && this.checkIfAlarmExists("al4"),
          activationOnly: true
        });
      }
      this.types = temp;
      this.available = temp.filter((val) => {
        return val.disabled
       }) ;
    },
    checkIfAlarmExists(type) {
      let exists = this.alarms.findIndex(x => x.type === String(type));
      return exists < 0 ? true : false;
    },
    sortCompare(a, b, key) {
      if (a < b) {
        return 1;
      } else if (a > b) {
        return -1;
      } else if (a == b) {
        return 0;
      }
    },
    onDelete(alarm) {
      if(this.poolData.isDemo){
        let alarmIndex = this.alarms.findIndex(
          x => x.id === alarm.id
        );
        if (alarmIndex >= 0) {
          this.$refs.modal.hide();
          this.alarms.splice(alarmIndex, 1);
        }
        return 
      }
      // Deleting alarm / sending data
      this.$snotify.async(
        this.$t("messages.alertDeletingAlarm"),
        this.$t("messages.alertSendingData"),
        () =>
          new Promise((resolve, reject) => {
            this.$store
              .dispatch("deleteAlarm", {
                id: alarm.id
              })
              .then(
                response => {
                  resolve({
                    // Alarm deleted!
                    title: this.$t("messages.alarmDeleted"),
                    config: {
                      timeout: 2000,
                      closeOnClick: true
                    }
                  });
                  let alarmIndex = this.alarms.findIndex(
                    x => x.id === alarm.id
                  );
                  if (alarmIndex >= 0) {
                    this.$refs.modal.hide();
                    this.alarms.splice(alarmIndex, 1);
                  }
                },
                error => {
                  console.log(error);
                  reject({
                    // error deleting alarm
                    title: this.$t("messages.retrieveDataError"),
                    body: error,
                    config: {
                      timeout: 3000,
                      closeOnClick: true
                    }
                  });
                }
              );
          })
      );
    },
    onUpdate() {
      if (!this.selectedAlarm.id) {
        this.onAdd();
      }else if(this.poolData.isDemo){
        this.$modal.hide("add-alarm");
        let alarmIndex = this.alarms.findIndex(
          x => x.id === this.selectedAlarm.id
        );

        if (alarmIndex >= 0) {
          this.$modal.hide("add-alarm");
          Vue.set(this.alarms, alarmIndex, this.selectedAlarm);
        }
      } else {
        // Updating alarm / Sending data
        this.$snotify.async(
          this.$t("messages.alertUpdatingAlarm"),
          this.$t("messages.alertSendingData"),
          () =>
            new Promise((resolve, reject) => {
              this.$store
                .dispatch("updateAlarm", {
                  id: this.selectedAlarm.id,
                  fields: this.selectedAlarm
                })
                .then(
                  response => {
                    resolve({
                      // updated
                      title: this.$t("messages.addedAlarm"),
                      config: {
                        timeout: 2000,
                        closeOnClick: true
                      }
                    });
                    let alarmIndex = this.alarms.findIndex(
                      x => x.id === this.selectedAlarm.id
                    );

                    if (alarmIndex >= 0) {
                      this.$modal.hide("add-alarm");
                      Vue.set(this.alarms, alarmIndex, this.selectedAlarm);
                    }
                  },
                  error => {
                    reject({
                      // error updating
                      title: this.$t("messages.updatingAlarm"),
                      body: error,
                      config: {
                        timeout: 3000,
                        closeOnClick: true
                      }
                    });
                  }
                );
            })
        );
      }
    },
    onAdd() {
      if(this.poolData.isDemo){
        this.selectedAlarm["id"] = 'demo'+ Math.random()*10;
        this.alarms.push(this.selectedAlarm);
        this.$modal.hide("add-alarm");
      }else{
      //Add properties
      this.selectedAlarm["pool"] = this.poolData.id;
      this.selectedAlarm["createdAt"] = Math.floor(Date.now() / 1000);
      this.selectedAlarm["lastSend"] = 0;
      // Adding alarm / Sending data
      this.$snotify.async(
        this.$t("messages.alertAddingAlarm"),
        // this.$t("messages.alertSendingData"),
        () =>
          new Promise((resolve, reject) => {
            this.$store
              .dispatch("addAlarm", {
                fields: this.selectedAlarm
              })
              .then(
                response => {
                  resolve({
                    //    added new alarm
                    title: this.$t("messages.addedAlarm"),
                    config: {
                      timeout: 2000,
                      closeOnClick: true
                    }
                  });
                  this.selectedAlarm["id"] = response.id;
                  this.alarms.push(this.selectedAlarm);
                  this.$modal.hide("add-alarm");
                },
                error => {
                  console.log(error);
                  reject({
                    // error adding alarm
                    title: this.$t("messages.addingAlarm"),
                    body: error,
                    config: {
                      timeout: 3000,
                      closeOnClick: true
                    }
                  });
                }
              );
          })
      );
    }
  }
}
};
</script>
<style>
.modal-detail {
  border-radius: 5px;
  background: #f7f7f7;
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}

.modal-detail-content {
  padding: 10px;
  height: 500px;
}

.modal-pos .modal-content {
    width: calc(100% - 2rem);
    min-height: 100%;
    height: auto;
    margin: 5rem;
}

.loadingAlpha {
  opacity: 0.5;
}
.b-table.poolTable td, .b-table.poolTable th{min-width:10px !important;}
.b-table.fullTable td, .b-table.fullTable th{min-width:10px !important;text-align:center !important;}

</style>


// WEBPACK FOOTER //
// src/components/Alarms.vue